import { route as laravelRoute } from 'ziggyRoute';
import { clientApi } from '@phoenix/clientApi';

const weBoutiqueLinkBtn = document.querySelector('#weboutique-link-btn');

if (weBoutiqueLinkBtn) {
  weBoutiqueLinkBtn.addEventListener('click', async () => {
    const reference = weBoutiqueLinkBtn.getAttribute('data-reference');
    Toolkit.helpers.buttons.addLoadingState(weBoutiqueLinkBtn);

    try {
      const { data } = await clientApi.get(laravelRoute('products.weBoutiqueLink', { reference }));

      if (!data?.data?.link) {
        throw new Error(window.Phoenix.i18n.t('error.couldNotLoadWeBoutiqueLink'));
      }

      window.location.href = data.data.link;
    } catch (e) {
      window.Phoenix.toaster.notify({
        type: 'danger',
        text: e.message,
      });
    }

    Toolkit.helpers.buttons.removeLoadingState(weBoutiqueLinkBtn);
  });
}
